// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"bbe9bdef","232":"2356529c","272":"580181d1","448":"f9103585","584":"32223631","592":"ef914f17","596":"100da49d","624":"8904d7cb","658":"008616f0","756":"cd3e87ba","792":"cd736611","852":"249fe794","900":"1ffb7bad"}[chunkId] + ".chunk.js";
};